/* eslint-disable import/prefer-default-export */
export const msgs = {
  neo: {
    common: {
      browse: {
        id: 'neo.common.browse',
        defaultMessage: 'browse',
      },
    },
    upload: {
      fileTypeNotSupported: {
        id: 'neo.upload.fileTypeNotSupported',
        defaultMessage: 'File type not supported. Try again.',
      },
      fileSizeExceeds: {
        id: 'neo.upload.fileSizeExceeds',
        defaultMessage: 'File size exceeds {maxFileSize}MB limit. Try again.',
      },
      maxFilesReached: {
        id: 'neo.upload.maxFilesReached',
        defaultMessage: 'Max files reached.',
      },
      maxUploadSizeReached: {
        id: 'neo.upload.maxUploadSizeReached',
        defaultMessage: 'Max upload size reached.',
      },
      maxFileCount: {
        id: 'neo.upload.maxFileCount',
        defaultMessage: 'Max {maxFileCount} files.',
      },
      maxFileSize: {
        id: 'neo.upload.maxFileSize',
        defaultMessage: 'Max {maxFileSizeString} per file.',
      },
      allowedTypesInfoTooltip: {
        id: 'neo.upload.allowedTypesInfoTooltip',
        defaultMessage: 'Allows {acceptTypes} files.',
      },
      dragAndDropOr: {
        id: 'neo.upload.dragAndDropOr',
        defaultMessage: 'Drag and drop or',
      },
      totalUploadSizeCantExceed: {
        id: 'neo.upload.totalUploadSizeCantExceed',
        defaultMessage: "Total upload size can't exceed {maxTotalFileSize}MB.",
      },
      attachmentSizeCantExceed: {
        id: 'neo.upload.attachmentSizeCantExceed',
        defaultMessage: "Attachments can't exceed {maxFileSize}MB.",
      },
      headerText: {
        id: 'neo.upload.headerText',
        defaultMessage: 'Upload a File',
      },
      headerTextPlural: {
        id: 'neo.upload.headerTextPlural',
        defaultMessage: 'Upload Files',
      },
    },
  },
};
